import React, { useEffect, useState, useCallback } from "react";
import { Row, Col } from "react-bootstrap";
import { axiosInstance } from "lib/axios";
import { ColorRing } from "react-loader-spinner";
import { toast } from "react-toastify";
import { pdfjs } from "react-pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import useAppStore from "store/global";
import { NavHeader } from "components/layout/NavHeader";
import { InvoiceHeader } from "components/layout/InvoiceHeader";
import { PDFComponent } from "../PDFComponent";
import TableComponent from "../TableComponent";
import { useCommonIssuesActions } from "store/commonIssues";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import useInvoicePagination from "store/invoicePagination";
import { useFetchDuplicateInvoices } from "components/api/api";
import { Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default function Mainx() {
  const scale = useAppStore((state) => state.scale);
  const pageNumber = useInvoicePagination((state) => state.pageNumber);
  const {
    tableData,
    setTableData,
    pdfUrl,
    setPdfUrl,
    rotation,
    setInvoiceNum,
    setInvoiceDate,
    setdueDate,
    setvendorName,
    setInvoiceBalance,
    setInvoiceTotal,
    setInvoicePaymentTerms,
    setInvoiceRemitTo,
    setInvoiceRoute,
    setInvoiceShipTo,
    invoiceUUID,
    setInvoiceBillTo,
    setInvoiceType,
    setInvoiceGlobalAddresses,
    setInvoiceSoldTo,
    setTotalPagesRcvd,
    setTotalPagesInInvoice,
    setTotalPagesInInvoiceFromGlobal,
    setvendorNamesSource,
    setTotalPagesProcessed,
    setHumanVerificationReqd,
    setInvoiceTotalFromtable,
    setInvoiceDiscount,
    setInvoiceTaxes,
    setFailedReasons,
    setVerdict,
    setConcerns,
    loading,
    setLoading,
    invoiceTableData,
    setInvoiceTableData,
    combinedTableData,
    setCombinedTableData,
    setExtraChargesAdded,
    setExtraFeesAdded,
    setExtraDiscountsAdded,
    setRespData,
    selectedFilter,
    setAdditionalCols,
    setAdditionalHeaders,
    setCategoryChoices,
    setNumberOfRows,
    setAdditionalColsTables,
    saved,
    setSaved,
    getVerified,
    setStatus,
    showVertical,
    setBlobPath,
    setPdfSource,
    setVersion,
    setDocumentTypePrediction,
    setInvoiceUUID,
    setRerunStatus,
    serVersion,
    setCategoryWiseSum,
    setQuickBooksDocType,
    setIsVendorVerified,
    setIsAddressVerified,
    setRestaurantsId,
    setVendorAddress,
    setBranchId,
    setVendorId,
    branchId,
    vendorId,
    setCreditCardName,
    setCreditCardNumber,
    setScale,
    lockZoomAndScroll,
    setPageNum,
    setLineItemMetaData,
    setRestaurantName,
    setAcceptAndRejectControl,
    setHumanVerified,
    setIsRejected,
    setLatestUpdateInfo
  } = useAppStore();

  const { setIssues, setUUID } = useCommonIssuesActions();
  const { uuid, page } = useParams();
  const [hoveredCellCoordinates, setHoveredCellCoordinates] = useState(null);
  const [multipleboundingBoxes, setMultipleBoundingBoxes] = useState(false);
  const [isPdfFetched, setIsPdfFetched] = useState(false);
  const [pdfDocument, setPdfDocument] = useState(null);
  const [singleCellCoordinates, setSingleCellCoordinates] = useState(null);
  const { data, isLoading } = useFetchDuplicateInvoices(
    invoiceUUID?.toString()
  );
  const rotateCoordinates = useCallback(
    (coordinates, rotation) => {
      const rotatedCoordinates = coordinates.map(({ x, y }) => {
        let newX = x;
        let newY = y;
        if (rotation === 90) {
          newX = y;
          newY = 1 - x;
        } else if (rotation === 180) {
          newX = 1 - x;
          newY = 1 - y;
        } else if (rotation === 270) {
          newX = 1 - y;
          newY = x;
        }
        return { x: newX, y: newY };
      });
      return rotatedCoordinates;
    },
    [rotation]
  );

  const calculatePixelCoordinates = (
    normalizedCoordinates,
    pageWidth,
    pageHeight,
    scale
  ) => {
    const pixelCoordinates = {
      x: normalizedCoordinates.X * pageWidth * scale,
      y: normalizedCoordinates.Y * pageHeight * scale
    };
    return pixelCoordinates;
  };

  function handlePdfPage(pdf, normalizedCoordinates, pageNumber, scale) {
    pdf
      .getPage(pageNumber)
      .then((page) => {
        const pageWidth = page.view[2];
        const viewport = page.getViewport({ scale });
        const pageHeight = page.view[3];
        let pixelCoordinates = [];
        normalizedCoordinates.map((normalizedCoordinate) => {
          const pixelCoordinate = calculatePixelCoordinates(
            normalizedCoordinate,
            pageWidth,
            pageHeight,
            scale
          );
          pixelCoordinates.push(pixelCoordinate);
        });

        const boundingBox = {
          page: pageNumber,
          coordinates: pixelCoordinates
        };

        const reactPdfWrapper = document.getElementById("react-pdf__Wrapper");
        if (reactPdfWrapper) {
          reactPdfWrapper.scroll({
            top: pixelCoordinates[0].y - 100,
            left: pixelCoordinates[0].x - 50,
            behavior: "smooth"
          });
        }
        setSingleCellCoordinates(boundingBox);
      })
      .catch((error) => {
        setPageNum(1)
        console.error("Error fetching PDF page dimensions:", error);
      });
  }

  function handleCellHover(normalizedCoordinates, pageNumber) {
    if (normalizedCoordinates == null) {
      setSingleCellCoordinates(null);
      if (lockZoomAndScroll === true) {
        return;
      }
      setScale(1.0);
      const reactPdfWrapper = document.getElementById("react-pdf__Wrapper");
      if (reactPdfWrapper) {
        reactPdfWrapper.scrollTop = 0;
      }
      return;
    }

    const HOVER_ZOOMIN_SCALE = lockZoomAndScroll
      ? scale
      : scale < 2
      ? 2.0
      : scale;
    setPageNum(pageNumber);
    setScale(HOVER_ZOOMIN_SCALE);

    // Check if the PDF document is already fetched
    if (isPdfFetched) {
      // Use the existing PDF document
      handlePdfPage(
        pdfDocument,
        normalizedCoordinates,
        pageNumber,
        HOVER_ZOOMIN_SCALE
      );
    } else {
      // Fetch the PDF document
      pdfjs
        .getDocument(pdfUrl)
        .promise.then((pdf) => {
          setPdfDocument(pdf); // Store the PDF document for reuse
          setIsPdfFetched(true); // Update the state variable
          handlePdfPage(
            pdf,
            normalizedCoordinates,
            pageNumber,
            HOVER_ZOOMIN_SCALE
          );
        })
        .catch((error) => {
          console.error("Error fetching PDF document:", error);
        });
    }
  }

  function handleMultipleCellHover(normalizedCoordinatesArray, pageNumber) {
    if (
      !normalizedCoordinatesArray ||
      normalizedCoordinatesArray.length === 0 ||
      normalizedCoordinatesArray === null
    ) {
      setHoveredCellCoordinates(null);
      if (lockZoomAndScroll === true) {
        return;
      }
      const reactPdfWrapper = document.getElementById("react-pdf__Wrapper");
      if (reactPdfWrapper) {
        reactPdfWrapper.scrollTop = 0;
      }
      return;
    }
    setPageNum(pageNumber);
    console.log(
      "the normalized coordinates array is",
      normalizedCoordinatesArray
    );
    pdfjs
      .getDocument(pdfUrl)
      .promise.then((pdf) => {
        const promises = normalizedCoordinatesArray.map(
          async (row, rowIndex) => {
            const page = await pdf.getPage(pageNumber);
            const pageWidth = page.view[2];
            const pageHeight = page.view[3];

            console.log("coming here", row);
            // Use row.map instead of normalizedCoordinatesArray.map
            const coordinates = row.map((normalizedCoordinates) => {
              console.log(
                "first normalized coordinates",
                normalizedCoordinates
              );
              const pixelCoordinates = calculatePixelCoordinates(
                normalizedCoordinates,
                pageWidth,
                pageHeight,
                scale
              );
              return {
                coordinates: pixelCoordinates
              };
            });

            return coordinates;
          }
        );

        Promise.all(promises)
          .then((boundingBoxes) => {
            console.log("first bounding box", boundingBoxes);
            // Flatten the array of arrays into a single array of coordinates
            const flattenedCoordinates = boundingBoxes.flat();
            console.log("The flattened coordinates are", flattenedCoordinates);
            const reactPdfWrapper =
              document.getElementById("react-pdf__Wrapper");
            if (reactPdfWrapper) {
              reactPdfWrapper.scroll({
                top: flattenedCoordinates[0].coordinates.y - 100,
                left: flattenedCoordinates[0].coordinates.x - 50,
                behavior: "smooth"
              });
            }
            setHoveredCellCoordinates(flattenedCoordinates);
          })
          .catch((error) => {
            setPageNum(1)
            console.error("Error fetching PDF page dimensions:", error);
          });
      })
      .catch((error) => {
        console.error("Error fetching PDF:", error);
      });
  }
  const getExtractedInvoice = () => {
    // setLoading(true);
    const body = {
      uuid: uuid
    };
    const apiUrl = "/get_extracted_invoices_by_uuid";
    axiosInstance
      .post(apiUrl, body)
      .then((response) => {
        // Get data for table
        const data = response.data.response.invoice || {};
        setLatestUpdateInfo(response?.data?.response?.latest_update_info);
        setPdfUrl(response.data?.response?.pdf_link);
        setLineItemMetaData(response?.data?.response?.line_item_metadata);
        setBlobPath(response.data?.response?.blob_path);
        setPdfSource(response.data?.response?.pdf_source);
        setVendorId(response.data.response.vendor_details.vendor_id);
        setBranchId(response.data.response.vendor_details.branch_id);
        console.log(vendorId, branchId);
        const issues =
          response.data?.response?.common_issues_in_invoice_extraction;
        issues && setIssues(issues);
        setUUID(response.data?.response?.uuid);
        if (Object.keys(data).length === 0) {
          toast.error("No data found for this invoice");
          setStatus(false);
          setTableData([]);
          setLoading(false);
          // setPdfUrl(response.data.response.pdf_link);
          setInvoiceNum(response.data.response.invoice_number);
          return;
        }

        const keys = Object.keys(data);
        const tableData = [];

        for (let i = 0; i < Object.values(data[keys[0]]).length; i++) {
          const obj = {};
          for (const key of keys) {
            obj[key] = data[key][i];
          }
          tableData.push(obj);
        }

        setTableData(tableData);

        // Get data for invoice table
        const data0 = response.data.response.invoice_1;
        if (Object.keys(data0).length === 0) {
          setInvoiceTableData([]);
          setLoading(false);
          // setPdfUrl(response.data.response.pdf_link);
          setInvoiceNum(response.data.response.invoice_number);
        }

        const keys0 = Object.keys(data0);
        const invoicetableData = [];

        for (let i = 0; i < Object.values(data0[keys0[0]]).length; i++) {
          const obj = {};
          for (const key of keys0) {
            obj[key] = data0[key][i];
          }
          invoicetableData.push(obj);
        }
        setInvoiceTableData(invoicetableData);

        // Get data for additional table
        const data1 =
          response.data.response.additional_columns[
            "combined_additional_columns"
          ];
        if (data1 && Object.keys(data1).length === 0) {
          setAdditionalCols([]);
          setLoading(false);
        }
        if (data1 && Object.keys(data1).length > 0) {
          const keys1 = Object.keys(data1);
          const additionaltableData = [];

          for (let i = 0; i < Object.values(data1[keys1[0]]).length; i++) {
            const obj = {};
            for (const key of keys1) {
              obj[key] = data1[key][i];
            }
            additionaltableData.push(obj);
          }
          setAdditionalCols(additionaltableData);
        } else {
          setAdditionalCols([]);
        }

        //Get data for the combined table
        const data2 = response.data.response.combined_invoice;
        if (data2 && Object.keys(data2).length === 0) {
          setCombinedTableData([]);
          setLoading(false);
        }
        if (data2 && Object.keys(data2).length > 0) {
          const keys2 = Object.keys(data2);
          const combinedData = [];

          for (let i = 0; i < Object.values(data2[keys2[0]]).length; i++) {
            const obj = {};
            for (const key of keys2) {
              obj[key] = data2[key][i];
            }
            combinedData.push(obj);
          }
          setCombinedTableData(combinedData);
        } else {
          setCombinedTableData([]);
        }

        setAdditionalColsTables(
          response.data.response.additional_columns[
            "table_specific_additional_columns"
          ]
        );
        // setPdfUrl(response.data.response.pdf_link);
        setInvoiceNum(response.data.response.invoice_metadata.invoice_number);
        setCategoryChoices(response.data.response.category_choices);
        setInvoiceDate(response.data.response.invoice_metadata.invoice_date);
        setvendorName(response.data.response.invoice_metadata.vendor_name);
        setVendorAddress(
          response.data.response.invoice_metadata.vendor_address
        );
        setCreditCardName(
          response.data.response.invoice_metadata.credit_card_name
        );
        setCreditCardNumber(
          response.data.response.invoice_metadata.credit_card_number
        );
        setIsVendorVerified(
          response.data.response?.vendor_details?.vendor_human_verified || false
        );
        setIsAddressVerified(
          response.data.response?.vendor_details?.branch_human_verified || false
        );
        setBranchId(response.data.response?.vendor_details?.branch_id);
        setVendorId(response.data.response?.vendor_details?.vendor_id);
        setdueDate(response.data.response.invoice_metadata.invoice_due_date);
        setInvoiceBalance(
          response.data.response.invoice_metadata.invoice_balance_due
        );
        setInvoiceTotal(
          response.data.response.invoice_metadata.invoice_total_amount
        );
        setInvoicePaymentTerms(
          response.data.response.invoice_metadata.invoice_payment_terms
        );
        setInvoiceRemitTo(
          response.data.response.invoice_metadata.invoice_remit_to
        );
        setInvoiceRoute(response.data.response.invoice_metadata.invoice_route);
        setInvoiceShipTo(
          response.data.response.invoice_metadata.invoice_ship_to
        );
        setInvoiceBillTo(
          response.data.response.invoice_metadata.invoice_bill_to
        );
        setInvoiceType(response.data.response.invoice_type);
        setInvoiceGlobalAddresses(
          response.data.response.invoice_metadata.invoice_global_addresses
        );
        setInvoiceSoldTo(
          response.data.response.invoice_metadata.invoice_sold_to
        );
        setTotalPagesRcvd(
          response.data.response.invoice_metadata.total_number_of_pages_received
        );
        setTotalPagesInInvoice(
          response.data.response.invoice_metadata.total_pages_in_invoice
        );
        setTotalPagesInInvoiceFromGlobal(
          response.data.response.invoice_metadata
            .total_pages_in_invoice_from_global
        );
        setHumanVerified(
          response.data.response.human_verification_info.human_verified
        );
        setIsRejected(response.data.response.human_verification_info.rejected);
        setvendorNamesSource(
          response.data.response.invoice_metadata.vendor_name_source
        );
        setTotalPagesProcessed(
          response.data.response.invoice_metadata
            .total_number_of_pages_processed
        );
        setHumanVerificationReqd(
          response.data.response.human_verification_info
            .human_verification_required
        );
        setInvoiceTotalFromtable(
          response.data.response.invoice_metadata.invoice_total_from_table
        );
        setQuickBooksDocType(
          response.data.response.invoice_metadata.quick_book_document_type
        );
        setInvoiceDiscount(
          response.data.response.invoice_metadata.invoice_discount
        );
        setInvoiceTaxes(response.data.response.invoice_metadata.invoice_taxes);
        setVerdict(response.data.response.human_verification_info.verdict);
        setHumanVerified(
          response.data.response.human_verification_info.human_verified
        );
        setIsRejected(response.data.response.human_verification_info.rejected);
        setFailedReasons(
          response.data.response.human_verification_info.failed_reasons
        );
        setConcerns(response.data.response.human_verification_info.concerns);
        let extra_charges_added =
          response.data.response.invoice_metadata.extra_charges_added;
        if (!extra_charges_added || extra_charges_added[0] === "NA") {
          extra_charges_added = [0];
        }
        setExtraChargesAdded(extra_charges_added);
        let extra_fees_added =
          response.data.response.invoice_metadata.extra_fees_added;
        if (!extra_fees_added || extra_fees_added[0] === "NA") {
          extra_fees_added = [0];
        }
        setExtraFeesAdded(extra_fees_added);
        let extra_discounts_added =
          response.data.response.invoice_metadata.extra_discounts_added;
        if (!extra_discounts_added || extra_discounts_added[0] === "NA") {
          extra_discounts_added = [0];
        }

        setExtraDiscountsAdded(extra_discounts_added);
        setRespData(response.data.response);
        setAdditionalHeaders(
          response.data.response.invoice_metadata
            .processed_table_header_candidates
        );
        setNumberOfRows(
          response.data.response.invoice_metadata.number_of_rows_in_tables
        );
        setVersion(response.data.response.version);
        setDocumentTypePrediction(
          response.data.response.document_type_prediction
        );
        setInvoiceUUID(response.data.response.uuid);
        setRestaurantsId(response.data.response.restaurant_id);
        setRestaurantName(response.data.response.restaurant_name);
        setRerunStatus(response.data.response.rerun_status);
        setCategoryWiseSum(response.data.response.invoice_category_wise_sum);
        setBranchId(response.data.response.vendor_details.branch_id);
        setAcceptAndRejectControl(
          response.data.response.accept_and_reject_control
        );
        setLoading(false);
        setSaved(false);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getExtractedInvoice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  console.log(invoiceUUID);
  const [show, setShow] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  return (
    <>
      <NavHeader view="details" />
      <InvoiceHeader />
      {data?.duplicate_invoice_count > 0 && (
        <Alert
          show={show}
          variant="warning"
          className="mx-2 mt-2"
          onClose={() => {
            setShow(false);
          }}
          dismissible
        >
          <div className="d-flex justify-content-center">
            <p>Duplicate Invoices Found - {data?.duplicate_invoice_count}</p>{" "}
            <Alert.Link
              className="mx-2"
              onClick={() => {
                setModalShow(true);
              }}
            >
              Check Now
            </Alert.Link>
          </div>
        </Alert>
      )}
      <div
        className="mx-5"
        style={{
          marginTop: loading || getVerified === "false" ? "0px" : "35px"
        }}
      >

        {loading ? (
          <>
            <ColorRing
              visible={true}
              height="80"
              width="80"
              ariaLabel="blocks-loading"
              wrapperStyle={{}}
              wrapperClass="blocks-wrapper"
              colors={[
                "#F57E37",
                "#1BBEE9",
                "#F57E37",
                "#1BBEE9",
                "#F57E37",
                "#1BBEE9"
              ]}
            />
          </>
        ) : (
          <>
            {page === "pdf" ? (
              <>
                <PDFComponent
                  hoveredCellCoordinates={hoveredCellCoordinates}
                  setHoveredCellCoordinates={setHoveredCellCoordinates}
                  multipleBoundingBoxes={multipleboundingBoxes}
                  setMultipleBoundingBoxes={setMultipleBoundingBoxes}
                  toggleMultipleBoundingBoxes={handleMultipleCellHover}
                  singleCellCoordinates={singleCellCoordinates}
                />
              </>
            ) : page === "table" ? (
              <div className="mb-4" style={{ height: "530px" }}>
                <TableComponent
                  data={tableData}
                  setMultipleBoundingBoxes={setMultipleBoundingBoxes}
                  invoiceTableData={invoiceTableData}
                  getExtractedInvoice={getExtractedInvoice}
                  combinedTableData={combinedTableData}
                  setCombinedTableData={setCombinedTableData}
                />
              </div>
            ) : (
              <Row>
                <Col md={showVertical ? 12 : 6}>
                  <PDFComponent
                    setHoveredCellCoordinates={setHoveredCellCoordinates}
                    hoveredCellCoordinates={hoveredCellCoordinates}
                    multipleBoundingBoxes={multipleboundingBoxes}
                    setMultipleBoundingBoxes={setMultipleBoundingBoxes}
                    toggleMultipleBoundingBoxes={handleMultipleCellHover}
                    singleCellCoordinates={singleCellCoordinates}
                  />
                </Col>
                <Col md={showVertical ? 12 : 6}>
                  <div className="mb-4" style={{ height: "530px" }}>
                    <TableComponent
                      data={tableData}
                      invoiceTableData={invoiceTableData}
                      combinedTableData={combinedTableData}
                      setCombinedTableData={setCombinedTableData}
                      getExtractedInvoice={getExtractedInvoice}
                      onCellHover={handleCellHover}
                      setMultipleBoundingBoxes={setMultipleBoundingBoxes}
                      multipleBoundingBoxes={multipleboundingBoxes}
                      toggleMultipleBoundingBoxes={handleMultipleCellHover}
                    />
                  </div>
                </Col>
              </Row>
            )}
          </>
        )}
            <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%"
              }}
            >
              <p>Duplicate Invoices Found </p>
            </Modal.Title>{" "}
          </Modal.Header>
          <p
            style={{
              fontSize: 16,
              fontWeight: 600,
              paddingLeft: 38,
              textDecoration: "underline"
            }}
          >
            Current Invoice
          </p>
          <div
            style={{
              borderBottom: "1px solid #d1d5db",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <p
              style={{
                fontSize: 14,
                fontWeight: 600,
                paddingLeft: 20
              }}
            >
              Upload Date:{" "}
              {data?.current_invoice?.date_uploaded?.split(".")?.[0]}
            </p>
            <p
              style={{
                fontSize: 14,
                fontWeight: 600,
                paddingRight: 20
              }}
            >
              Human Verified:{" "}
              {data?.current_invoice?.human_verified ? "Yes" : "No"}
            </p>
            <p
              style={{
                fontSize: 14,
                fontWeight: 600,
                paddingRight: 20
              }}
            >
              Rejected: {data?.current_invoice?.rejected ? "Yes" : "No"}
            </p>
          </div>

          <Modal.Body>
            <p
              style={{
                fontSize: 16,
                fontWeight: 600,
                paddingLeft: 20,
                textDecoration: "underline"
              }}
            >
              Duplicate Invoices
            </p>
            <div className="d-flex justify-content-center mt-0">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Invoice</th>
                    <th scope="col">Human Verified</th>
                    <th scope="col">Rejected</th>
                    <th scope="col">Upload Date</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.duplicate_invoices?.map((invoice, index) => (
                    <tr>
                      <th scope="row">{index + 1}</th>
                      <td>
                        <Link
                          to={`/invoice-details/${invoice.document_uuid}`}
                          target="_blank"
                        >
                          View
                        </Link>
                      </td>
                      <td>{invoice?.human_verified ? "Yes" : "No"}</td>
                      <td>{invoice?.rejected ? "Yes" : "No"}</td>
                      <td>{invoice?.date_uploaded?.split(".")?.[0]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
